<ui-button
	data-cy="subscription-notify-request-renewal"
	[href]="renewalMailtoLink()"
	[text]="'general.subscription_renewal.request' | translate"
	[type]="UIThemes.Blue"
></ui-button>
